import { useState, useEffect } from 'react';
import { STORE } from '@/lib/store';

const TSPM_URL = 'https://tspm-api.abrandfantastic.workers.dev/api/site-content';

// Singleton promise to avoid redundant fetches from multiple components
let contentPromise = null;

function fetchContent() {
  if (!contentPromise) {
    contentPromise = fetch(TSPM_URL, { signal: AbortSignal.timeout(4000) })
      .then(r => r.ok ? r.json() : null)
      .catch(() => null);
  }
  return contentPromise;
}

// Fetches site content from TSPM and resolves store-specific keys.
export function useSiteContent(defaults) {
  const [content, setContent] = useState(defaults);

  useEffect(() => {
    fetchContent().then(data => {
      if (!data) return;
      const resolved = { ...defaults };
      let hasChanged = false;

      for (const key of Object.keys(defaults)) {
        const storeSpecific = STORE !== 'rad' ? data[`${STORE}_${key}`] : undefined;
        const bare = data[key];
        const value = (storeSpecific !== undefined && storeSpecific !== '') ? storeSpecific
                    : (bare !== undefined && bare !== '') ? bare
                    : defaults[key];

        if (value !== defaults[key]) {
          resolved[key] = value;
          hasChanged = true;
        }
      }

      // Only update state if content actually differs from defaults to reduce re-renders
      if (hasChanged) {
        setContent(resolved);
      }
    });
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return content;
}
